// extracted by mini-css-extract-plugin
module.exports = {"backward":"backward_backward__2AZkn"};